import React, { useState } from 'react';
import { Flex, Spinner, Text, Link, useToast } from '@chakra-ui/react';
import { useGoogleCalendarSettings } from 'hooks/useGoogleCalendarSettings';

const GoogleAuthPrompt = () => {
    const toast = useToast();
    const { getAuthUrl } = useGoogleCalendarSettings();

    // States for Google Auth Prompt
    const [authUrlLoading, setAuthUrlLoading] = useState(false);
    // Fetch auth URL if not already fetched
    const handleFetchAuthUrl = async (e) => {
        e.preventDefault();
        setAuthUrlLoading(true);
        try {
            const url = await getAuthUrl();
            window.open(url, '_blank', 'noopener,noreferrer');
        } catch (err) {
            toast({
                title: "Failed to get authorization link",
                description: "Please try again later.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setAuthUrlLoading(false);
        }
    };

    if (authUrlLoading) {
        return (
            <Flex align='center'>
                <Spinner size='sm' mr={2} />
                <Text>Generating authorization link...</Text>
            </Flex>
        );
    }
    // Show button to fetch auth URL if not yet fetched
    return (
        <Text color='gray.500'>
            <Link href="#" color="blue.500" onClick={handleFetchAuthUrl}>Click here to authorize google.</Link>
        </Text>
    );
};

export default GoogleAuthPrompt;